import React, { useMemo } from 'react'
import { rankWith, and, scopeEndsWith } from '@jsonforms/core'
import { withJsonFormsControlProps } from '@jsonforms/react'

import ComponentWrapper from 'designer/component/display/layout/control/ComponentWrapper'
import DragContainerWrapper from 'designer/component/system/layout/control/DragContainerWrapper'
import CustomCollapse from 'designer/component/container/collapse/Collapse'
import {
  createDisplayRenderer,
  createSystemRenderer,
} from 'designer/component/control/renderer'
import Container from './Container'

const collapseTester = rankWith(
  3,
  and(scopeEndsWith('collapse'), (schema) => !schema.subGroup),
)

const subCollapseTester = rankWith(
  3,
  and(scopeEndsWith('collapse'), (schema) => schema.subGroup),
)

export const CollapseSystem = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createSystemRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  return (
    <DragContainerWrapper {...props}>
      <CustomCollapse {...props}>
        <Container {...props} renderers={renderers} />
      </CustomCollapse>
    </DragContainerWrapper>
  )
}

export const SubCollapseSystem = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createSystemRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  return (
    <DragContainerWrapper {...props}>
      <CustomCollapse {...props}>
        <Container {...props} renderers={renderers} />
      </CustomCollapse>
    </DragContainerWrapper>
  )
}

export const CollapseDisplay = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createDisplayRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  return (
    <ComponentWrapper {...props}>
      <CustomCollapse {...props}>
        <Container {...props} renderers={renderers} />
      </CustomCollapse>
    </ComponentWrapper>
  )
}

export const SubCollapseDisplay = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createDisplayRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  return (
    <ComponentWrapper {...props}>
      <CustomCollapse {...props}>
        <Container {...props} renderers={renderers} />
      </CustomCollapse>
    </ComponentWrapper>
  )
}

export const collapseSystem = {
  tester: collapseTester,
  renderer: withJsonFormsControlProps(CollapseSystem),
}

export const subCollapseSystem = {
  tester: subCollapseTester,
  renderer: withJsonFormsControlProps(SubCollapseSystem),
}

export const collapseDisplay = {
  tester: collapseTester,
  renderer: withJsonFormsControlProps(CollapseDisplay),
}

export const subCollapseDisplay = {
  tester: subCollapseTester,
  renderer: withJsonFormsControlProps(SubCollapseDisplay),
}
